import React, { useEffect } from "react";
import styled from "styled-components";

import Card from "../components/Card";
import CartSummary from "../components/CartSummary";
import CompleteTheLook from "../components/CompleteTheLook";
import PaymentSummary from "../components/PaymentSummary";
import ProductCarousel from "../components/ProductCarousel";
import { useCartContext } from "../context/CartContext";
import { useRecommendationContext } from "../context/RecommendationContext";

const CartPage = () => {
  const { cartItems } = useCartContext();

  const { styleRecommendations, getStyleRecommendation } =
    useRecommendationContext();

  const ids = cartItems.map((item: any) => item.id);

  useEffect(() => {
    getStyleRecommendation(ids);
    //eslint-disable-next-line
  }, ids);

  return (
    <Wrapper>
      <div className="section section-center-cart page-100">
        <div className="row">
          <CartSummary className={"bigCard"} cartItems={cartItems} />
          <PaymentSummary className={"smallCard"} />
        </div>
        <Card
          className={"bigCard"}
          title={"Style Your Items with"}
          color={"#FFF"}
        >
          <CompleteTheLook title={""} recommendations={styleRecommendations} />
        </Card>
        <Card
          className={"bigCard"}
          title={"You Might Also Like"}
          color={"#FFF"}
        >
          <ProductCarousel className={"cartProductRec"} title={""} cart />
        </Card>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: #f9f9f9;
  .row {
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 3rem;
  }

  .cartProductRec {
    padding-bottom: 30px;
  }

  .bigCard {
    padding: 2.5rem 3.5rem;
  }

  .smallCard {
    padding: 2.5rem 1.5rem;
  }
`;

export default CartPage;
